import React, {useEffect} from 'react'
import WOW from 'react-wow'
import {Container, Row, Col} from '@bootstrap-styled/v4'
import {StaticQuery, graphql} from 'gatsby'

import Button from 'src/components/ui/Button'
import ProjectSlider from './ProjectSlider'
import * as S from './styled'

const ProjectContent = ({
    title,
    date,
    link_ext,
    category,
    proposta,
    description,
    gallery,
    cliente,
    image
}) => {

    if (gallery) {
        gallery.splice(Math.ceil(gallery.length / 2), 0, image)
    } else {
        gallery = [image]
    }
    
    return (
        <StaticQuery
            query={graphql `query { divisorImg: file(relativePath: { eq: "trumps/lotus-y.png"}){ childImageSharp { fluid(maxWidth: 80){ ...GatsbyImageSharpFluid } } } } `}
            render={data => (
            <S.ProjectWrapper>
                <Container>
                    <WOW animation="fadeInUp">
                        <S.ProjectLinkBack to="/portfolio/">
                            <Button color={`primary`} size={`sm`} variant={`outline`}>
                                {`← Voltar para portfólio`}
                            </Button>
                        </S.ProjectLinkBack>
                    </WOW>
                    <Row>
                        <Col xs={12} sm={6} md={4}>
                            <WOW animation="fadeInUp">
                                <S.ProjectInfoItem>
                                    Cliente:
                                    <span>
                                        {cliente}
                                    </span>
                                </S.ProjectInfoItem>
                            </WOW>
                        </Col>
                        <Col xs={12} sm={6} md={4}>
                            <WOW animation="fadeInUp">
                                <S.ProjectInfoItem>
                                    Categoria:
                                    <span>
                                        {category
                                            .charAt(0)
                                            .toUpperCase() + category.slice(1)}
                                    </span>
                                </S.ProjectInfoItem>
                            </WOW>
                        </Col>
                        <Col xs={12} sm={6} md={4}>
                            <WOW animation="fadeInUp">
                                <S.ProjectInfoItem>
                                    Data:
                                    <span>
                                        {date}
                                    </span>
                                </S.ProjectInfoItem>
                            </WOW>
                        </Col>
                    </Row>
                    <WOW animation="fadeInUp">
                        <S.ProjectText>
                            <S.ProjectTitle>
                                A proposta
                            </S.ProjectTitle>
                            <S.ProjectDescription>
                                {proposta}
                            </S.ProjectDescription>
                        </S.ProjectText>
                    </WOW>
                    <ProjectSlider items={gallery}/>
                    <WOW animation="fadeInUp">
                        <S.ProjectText>
                            {link_ext && <S.ProjectLink href={link_ext} target="_blank">
                                Acessar
                            </S.ProjectLink>}
                            <S.ProjectDescription>
                                {description}
                            </S.ProjectDescription>
                        </S.ProjectText>
                    </WOW>
                    <WOW animation="fadeInUp">
                        <S.ProjectDivisor fluid={data.divisorImg.childImageSharp.fluid}/>
                    </WOW>
                </Container>
            </S.ProjectWrapper>
        )}/>
    )
}

export default ProjectContent;